<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>
<script>
//test-local.smarket.net.cn:8080/index.html?tenantId=53&schemaId=66669508&memberFormId=66669596#/pc/basis
//dev-local.smarket.net.cn:8080/index.html?tenantId=52&schemaId=66669507&memberFormId=66669599#/pc/account
//test-local.smarket.net.cn:8080/index.html?tenantId=1038&schemaId=2668&memberFormId=7319#/pc/account
import {ck} from "fire-wind-water/cookie";
import {interact} from "fire-wind-water/tools/interact";
import {$subscriber} from "fire-wind-water/tools/subscriber";
import {
  userInfo,
  memberFormId,
  schemaId,
  tenantId,
  sess,
  setMemberFormInfo
} from "./common/sbase";
import member from "./services/member";
import {Subject, zip} from "rxjs";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  name: "App",
  data() {
    return {
      memberForm$: new Subject(),
      contactInfo$: new Subject(),
      locale: zhCN
    };
  },
  created() {
    this.getMemberForm();
    if (userInfo) {
      this.getContactInfo();
    }
    this.memberForm$.subscribe(data => {
      $subscriber.emit("s-member-init", data);
      setMemberFormInfo(data);
      var page = document.querySelector(".m-page-loading");
      if (page) {
        page.style.display = "none";
      }
    });
    this.contactInfo$.subscribe(data => {
      $subscriber.emit("s-contact-init", data);
    });
    zip(this.memberForm$, this.contactInfo$).subscribe(data => {
      if (data[1] === 401) {
        ck.removeCookie(`smarketMember_${schemaId}`, {
          path: "/",
          domain: window.$sk.config.domain
        });
        if (interact.isMobile == 1) {
          window.location.href =
              window.$sk.goto(data[0].originUrl.wap) +
              "&backUrl=" +
              encodeURIComponent(window.location.href);
        } else {
          window.location.href =
              window.$sk.goto(data[0].originUrl.pc) +
              "&backUrl=" +
              encodeURIComponent(window.location.href);
        }
      }
      setMemberFormInfo(data[0]);
      $subscriber.emit("s-member-contact", data);
    });
    $subscriber.on("s-contact-get", () => {
      this.getContactInfo();
    });
  },
  methods: {
    getMemberForm() {
      member
          .memberFormGet({
            memberFormId: memberFormId,
            schemaId: schemaId
          })
          .subscribe(data => {
            this.initMemberForm(data.content);
          });
    },
    initMemberForm(data) {
      if (!userInfo) {
        if (interact.isMobile == 1) {
          window.$sk.goto(data.originUrl.wap +
              "&backUrl=" +
              encodeURIComponent(window.location.href));
        } else {
          window.$sk.goto(data.originUrl.pc +
              "&backUrl=" +
              encodeURIComponent(window.location.href));
        }
      } else {
        this.memberForm$.next(data);
      }
    },
    getContactInfo() {
      member
          .contactGet({
            tenantId: tenantId,
            schemaId: schemaId,
            sess: sess,
            isTemplate: 1
          })
          .subscribe(data => {
            if (data.result == 0) {
              this.contactInfo$.next(data.content);
            } else if (data.result == 401) {
              this.contactInfo$.next(401);
            } else {
              this.$message.error(data.desc);
            }
          });
    }
  }
};
</script>
<style lang="scss"></style>
